<template lang="pug">
.card.mb-0
  .card-body
    .row
      .col-12.mb-1 
        .section-title.m-1 {{ operatorID }}
      .col-12 
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-12.mb-1
                .d-inline-block.mr-2
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.refresh') }}
                    b-input-group-text(slot="append")
                      label.custom-switch
                        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="refreshOn" @change="toggleRefresh()")
                        span.custom-switch-indicator
                    b-input-group-text(slot="append")
                      b-input(v-model="refreshInterval" type="range" min="1" max="5")
                    b-input-group-text(slot="append")
                      span {{ refreshInterval }} s
                .d-inline-block.mr-2
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.all_pending_ticket_voucher') }} 
                    b-input-group-text(slot="append")
                      label.custom-switch
                        input.custom-switch-input(type="checkbox" v-model="getAllPendingTicket" @change="getTicketList()")
                        span.custom-switch-indicator
                .d-inline-block
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.alert') }}
                    b-input-group-text(slot="append")
                      label.custom-switch
                        input.custom-switch-input(type="checkbox" v-model="alert")
                        span.custom-switch-indicator
              template(v-if="!getAllPendingTicket")
                .form-group.col-3.mb-1
                  b-input-group(size="sm")
                    b-form-select.col-4(v-model="searchType" size="sm" @input="resetInput()")
                      option(value="member") {{ $t('ui.member') }}
                      option(value="ticket") {{ $t('ui.ticket') }}
                    template(v-if="['member'].includes(searchType)")
                      DebounceInput(autofocus type="text" v-model="memberID" :placeholder="$t('message.search_member')" size="sm" @enter="getTicketList()")
                    template(v-if="['ticket'].includes(searchType)")
                      DebounceInput(autofocus type="text" v-model="ticketId" :placeholder="$t('message.search_by_' + searchType)" @enter="getTicketList()" size="sm")
                template(v-if="['member'].includes(searchType)")
                  .form-group.col-3.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        span {{ $t('ui.status') }}
                      b-form-select(v-model="ticketStatus" :disabled="loading" size="sm" @change="getTicketList")
                        option(value="") {{ $t('ui.all') }}
                        option(value="REJECTED") {{ $t('ui.rejected') }}
                        option(value="REJECTED(ONLOAD)") {{ $t('ui.rejected_onload') }}
                        option(value="PENDING") {{ $t('ui.pending') }}
                        option(value="PROCESSED") {{ $t("ui.processed") }}
                        option(value="PROCESSING") {{ $t("ui.processing") }}
                        option(value="PROCESSED(REJECTED)") {{ $t("ui.processed_rejected") }}
                //- .form-group.col-6.mb-1
                //-   b-input-group(size="sm")
                //-     b-input-group-text(slot="prepend")
                //-       span {{ $t('ui.alert') }}
                //-     b-input-group-text(slot="append")
                //-       label.custom-switch
                //-         input.custom-switch-input(type="checkbox" v-model="alert")
                //-         span.custom-switch-indicator
                template(v-if="['member'].includes(searchType)")
                  .form-group.col-12.mb-1
                    DateRangePicker(:value="dateRange" @update="getData")
              .form-group.col-12.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getTicketList()"
                  variant="primary"
                  size="sm"
                ).mr-2
                jsonToExcel(v-if="depositList.length > 0" mode="DepositList" tbl="tblDep" :date="dateRange" btnTxt="export_deposit").mr-2
                jsonToExcelFull(v-if="depositListFull.length > 0 && $helpers.showExportAll(dateRange) == true" mode="DepositList" tbl="tblDepFull" :date="dateRange" btnTxt="export_deposit_all" type="0" :loading2="loading2").mr-2
                depositTicketVoucherExport(v-if="depositList.length > 0" :tbl="depositList" :ticketStatus="ticketStatus" tblId="tblDep" :operatorView="operatorView")
                depositTicketVoucherExportFull(v-if="depositListFull.length > 0 && $helpers.showExportAll(dateRange) == true" :tbl="depositListFull" :ticketStatus="ticketStatus" tblId="tblDepFull" :operatorView="operatorView")

          .card-body
            .row
              .col-12
                ul#tickettab.nav.nav-tabs(role='tablist')
                  li.nav-item
                    a#deposit-tab.nav-link.active(data-toggle='tab' href='#deposit-content' role='tab' aria-controls='deposit' aria-selected='false') {{ $t("ui.deposit") }}

                #tickettabcontent.tab-content.tab-bordered
                  #deposit-content.tab-pane.active.show(role='tabpanel' aria-labelledby='deposit-tab')
                    .row
                      .col-10.mb-1
                        b-pagination.float-left(
                          size="sm"
                          hide-ellipsis
                          :total-rows="depTotalRow"
                          :per-page="getPageSize"
                          v-model="currentDepPage"
                          @input="changedDepPage($event)").mb-1
                      .col-2.mb-1
                        b-input-group(:prepend="$t('ui.page_size')" size="sm")
                          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedDepPageSize" size="sm")
                      .col-12
                        .clusterize-scroll.table-responsive
                          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                            thead.thead-light
                              tr
                                th.text-center(width="3%")
                                  span #
                                th(width="6%")
                                  span(:title="$t('ui.id')") {{ $t('ui.id') }}
                                //- th(width="6%")
                                //-   span(:title="$t('ui.ref_no')") {{ $t('ui.ref_no') }}
                                th(width="6%")
                                  span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                                th(width="6%")
                                  span(:title="$t('ui.member')") {{ $t('ui.member') }}
                                th(width="6%")
                                  span(:title="$t('ui.bank_acc_holder')") {{ $t('ui.bank_acc_holder') }}
                                th(width="6%")
                                  span(:title="$t('ui.mode')") {{ $t('ui.mode') }}
                                th.text-right(width="6%")
                                  span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                                th(width="6%")
                                  span(:title="$t('ui.promo')") {{ $t("ui.promo") }}
                                th(width="6%")
                                  span(:title="$t('ui.bonus_amount')") {{ $t("ui.bonus_amount") }}
                                th(width="6%")
                                  span(:title="$t('ui.upline')") {{ $t("ui.upline") }}
                                th(width="6%")
                                  span(:title="$t('ui.vip')") {{ $t("ui.vip") }}
                                th.text-center(width="5%")
                                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                                th.text-center(width="7%")
                                  span(:title="$t('ui.action')") {{ $t("ui.action") }}                                
                                th(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'" width="5%")
                                  span(:title="$t('ui.remark')") {{ $t("ui.remark") }}
                                th(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'" width="5%")
                                  span(:title="$t('ui.modified_by')") {{ $t("ui.modified_by") }}
                                th.text-right(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'" width="8%")
                                  span(:title="$t('ui.deposit_time')") {{ $t("ui.deposit_time") }}
                                th.text-right(width="8%")
                                  span(:title="$t('ui.submit_time')") {{ $t("ui.submit_time") }}
                            tbody.clusterize-content
                              tr(v-if="depositList.length == 0")
                                td(:colspan="ticketStatus.trim().toUpperCase() != 'PENDING' ? '17' : '14'").text-center
                                  span {{ $t('message.no_data_available') }}
                              tr(v-for="(item, index) in depositList" :class="$helpers.rowClassTicket(item, 'deposit')")
                                td.text-center
                                  span(:title="((currentDepPage - 1) * getPageSize + index + 1)") {{ ((currentDepPage - 1) * getPageSize + index + 1) }}
                                td
                                  span(:title="item.id") {{ item.id }}
                                  span.small.text-info.d-block(:title="getRefNo(item.target_bank_id, item.id, item.prefix_vch, item.prefix_delimiter)") {{ getRefNo(item.target_bank_id, item.id, item.prefix_vch, item.prefix_delimiter) }}
                                //- td
                                //-   span(:title="getRefNo(item.id, item.prefix_vch, item.prefix_delimiter)") {{ getRefNo(item.id, item.prefix_vch, item.prefix_delimiter) }}
                                td
                                  span(:title="item.parent_id") {{ item.parent_id }}
                                td
                                  span.font-weight-bold(:title="item.member_id")
                                    b-link.clickable(href="javascript:void(0);" @click="redirectToMemberDetails(item)" :title="item.member_id") {{ item.member_id }}
                                  //- span(:title="item.member_id") {{ item.member_id }}
                                td
                                  span(:title="item.target_bank_acc_holder") {{ item.target_bank_acc_holder }}
                                td
                                  span(:title="item.deposit_method") {{ item.deposit_method }}
                                  span.text-danger(v-if="item.rate != null && item.rate_php != null") ({{ item.rate }}/{{ item.rate_php }})
                                td.text-right
                                  span.font-weight-bold.d-block(:title="$n(item.amount, 'currency')"  :class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
                                  span.font-weight-bold.d-block(:class="{'text-danger': item.exchanged_amount > 0  }" v-if="item.exchanged_amount != null" :title="$n(item.exchanged_amount, 'currency')") ({{ $n(item.exchanged_amount, 'currency') }})
                                td
                                  span(:title="item.promotion_id") {{ item.promotion_id }}
                                td.text-right
                                  span.font-weight-bold.d-block(:title="$n(item.bonus_amount, 'currency')" :class="$helpers.fontClassName(item.bonus_amount)") {{ $n(item.bonus_amount, 'currency') }}
                                td
                                  span(:title="item.referrer_id") {{ item.referrer_id }}
                                td
                                  span(:title="item.vip_name") {{ item.vip_name }}
                                td.text-center
                                  span(v-if="item.status.trim().toUpperCase() == 'PENDING'" :class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
                                  span(v-if="item.status.trim().toUpperCase() == 'PROCESSED'" :class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
                                  span(v-if="item.status.trim().toUpperCase() == 'REJECTED' && item.reject_onload == false" :class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
                                  span(v-if="item.status.trim().toUpperCase() == 'REJECTED' && item.reject_onload == true" :class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
                                  span(v-if="item.status.trim().toUpperCase() == 'REJECTED' && item.reject_onload == true" :class="$helpers.badgeClass('onload')") (ONLOAD)
                                td.text-center
                                  span
                                    a.btn.btn-ssm.btn-info.btn-info.fa.fa-search(href="javascript:void(0)" @click="getTicketVoucherDetail(item, $event)" :title="$t('ui.view')")
                                  span.ml-1(v-if="item.attachment_path")
                                    a.btn.btn-ssm.btn-icon.btn-warning.fa.fa-paperclip(href="javascript:void(0)" @click="openAttachment(item)" :title="$t('ui.attachment')")
                                  template(v-if="isEditAccess")
                                    span.ml-1(v-if="item.status.trim().toUpperCase() == 'REJECTED'")
                                      a.btn.btn-ssm.btn-primary.fa.fa-check(href="javascript:void(0)" @click="redepositTicketVoucher(item, $event)" :title="$t('ui.redeposit')")
                                td(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'")
                                  span(:title="item.remark") {{ item.remark }}
                                td(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'")
                                  span(:title="item.modified_by") {{ item.modified_by }}
                                td.text-right(v-if="ticketStatus.trim().toUpperCase() != 'PENDING'")
                                  span(v-if="item.modified_date" :title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_date).format("YYYY-MM-DD, HH:mm:ss") }}
                                td.text-right
                                  span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}


    ticketvoucherdetail(ref="ticketvoucherdetail" :ticketId="selectedTicketId" @failed="handleFailed")
    redepositticketvoucher(ref="redepositticketvoucher" :ticketId="selectedTicketId" :memberId="selectedMemberId" @clicked="afterRedeposit" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import ValidateResult from "@/library/ValidateResult";
import ticketvoucherdetail from "@/components/ticketvoucher/ticketVoucherDetail.vue";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import jsonToExcelFull from "@/library/jsonToExcelFull.vue";
import jsonToExcel from "@/library/jsonToExcel.vue";
import depositTicketVoucherExport from "@/components/ticketvoucher/depositTicketVoucherExportFull.vue";
import depositTicketVoucherExportFull from "@/components/ticketvoucher/depositTicketVoucherExportFull.vue";
import redepositticketvoucher from "@/components/ticketvoucher/redepositTicketVoucher.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult,
    ticketvoucherdetail,
    DateRangePicker,
    jsonToExcelFull,
    jsonToExcel,
    depositTicketVoucherExport,
    depositTicketVoucherExportFull,
    redepositticketvoucher
  },
  data: () => ({
    loading2: false,
    loading: false,
    depositListFull: [],
    depositList: [],
    currentDepPage: 1,
    depTotalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null,
    },
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    ticketStatus: "",
    selectedTicketId: null,
    selectedTicket: null,
    selectedMemberId: null,
    al: null,
    ticketId: "",
    searchType: "member",
    memberID: "",
    getAllPendingTicket: false,
    ticketTimer: null,
    refreshOn: false,
    refreshInterval: 5,
    refreshChange: "",
    operatorView: true,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_ticketlistop");
    },
    alert:
    {
      get() {
        return this.$store.getters.alertOn;
      },
      set(value) {
        this.changedAlertOn(value);
      }
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  destroyed: function() {
    if (this.ticketTimer) {
      clearTimeout(this.ticketTimer);
    } 
  },
  mounted: function() {
    this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.getTicketList(true)
  },
  methods: {
    toggleRefresh: function() {
      this.startRefreshTimer();
    },
    startRefreshTimer: function() {
      if (this.ticketTimer) {
        clearTimeout(this.ticketTimer);
      }
      if (this.refreshOn) {
        this.searchType = "member";
        this.searchID = "";
        this.getTicketList();
        this.ticketTimer = setTimeout(() => {
          this.startRefreshTimer();
        }, this.refreshInterval * 1000);
      } else {
        this.refreshChange = "STOPPED";
      }
    },
    changedAlertOn: function(eventStatus) {
      this.$store.dispatch("user/setAlertOn", eventStatus);
    },
    getTextColor(backgroundColor) {
      if (!backgroundColor) return '#000000'; // Default to black if no color provided
      // Convert hex color to RGB
      const rgb = backgroundColor.replace('#', '').match(/.{1,2}/g).map((hex) => parseInt(hex, 16));
      // Calculate relative luminance
      const luminance = (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]) / 255;
      return luminance > 0.5 ? '#000000' : '#ffffff'; // Black for light backgrounds, white for dark
    },
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    redirectToMemberDetails: function(item) {
      var json = {
        member_id: item.member_id
      };

      this.$store.dispatch("user/setMemberDetailsParam", json);
      this.$store.dispatch("user/setSelectedOperatorID", item.parent_id);
      this.$router.push("/account/operator");
    },
    resetInput() {
      // this.depositList = [];
      this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.ticketStatus = "";
      this.ticketId = "";
      this.memberID = "";
    },
    getRefNo: function(bank_id, id, prefix, delimiter) {
      return this.$helpers.getPaymentGatewayRefNoSetMember(bank_id, id, prefix, delimiter);
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getTicketList(true);
    },
    getTicketList() {
      if (this.checkDateRange()) {
        this.getDepositList(true);
        if (this.$helpers.showExportAll(this.dateRange) == true) {
          this.getDepositListFull(true);
        }
      } else {
        this.depositList = [];
        this.depTotalRow = 0;
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    openAttachment(obj) {
      this.$store.dispatch("user/setAttachmentPath", obj.attachment_path);
      let routeData = this.$router.resolve({path: '/attachment'});
      window.open(routeData.href, '_blank', "toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=250,width=1500,height=800");
    },
    getDepositListFull: function(isSearch) {
      let url = config.ticketVoucherListUrl();
      if (isSearch) this.currentDepPage = 1;

      if(this.getAllPendingTicket) {
        url = config.ticketVoucherListPendingUrl();
        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          page_number: this.currentDepPage,
          page_size: -1,
          operator_id: this.operatorID == "" ? null : this.operatorID,
          ticket_id: null
        };
      } else {
        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          ticket_status: this.ticketStatus == "" ? null : this.ticketStatus,
          ticket_id: this.ticketId == "" ? null : this.$helpers.getTicketId(this.ticketId),
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          page_number: this.currentDepPage,
          page_size: -1,
          operator_id: this.operatorID == "" ? null : this.operatorID,
          member_id: this.memberID == "" ? null : this.memberID,
        };
      }

      if(this.searchType == 'operator') {
        if(this.operatorID == '' || this.operatorID == null) {
          this.depositList = [];
          this.depTotalRow = 0;
          return
        }
      }

      this.loading2 = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading2 = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.depositListFull = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading2 = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getDepositList: function(isSearch) {
      let url = config.ticketVoucherListUrl();
      if (isSearch) this.currentDepPage = 1;

      if(this.getAllPendingTicket) {
        url = config.ticketVoucherListPendingUrl();
        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          page_number: this.currentDepPage,
          page_size: this.getPageSize,
          operator_id: this.operatorID == "" ? null : this.operatorID,
          ticket_id: null
        };
      } else {
        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          ticket_status: this.ticketStatus == "" ? null : this.ticketStatus,
          ticket_id: this.ticketId == "" ? null : this.$helpers.getTicketId(this.ticketId),
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          page_number: this.currentDepPage,
          page_size: this.getPageSize,
          operator_id: this.operatorID == "" ? null : this.operatorID,
          member_id: this.memberID == "" ? null : this.memberID,
        };
      }

      if(this.searchType == 'operator') {
        if(this.operatorID == '' || this.operatorID == null) {
          this.depositList = [];
          this.depTotalRow = 0;
          return
        }
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.depositList = response.data.dt;
                this.depTotalRow = this.depositList.length > 0 ? this.depositList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getTicketVoucherDetail: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.ticketvoucherdetail.$refs.ticketVoucherDetail.show();
    },
    afterRedeposit: function() {
      this.ticketStatus = "PROCESSED";
      this.getTicketList();
      this.$helpers.showDialog(this.$t("ui.combine.redeposit"), this.$t("message.success"), "success");
    },
    redepositTicketVoucher: function(e) {
      this.selectedTicketId = e.id;
      this.selectedMemberId = e.member_id;
      this.$refs.redepositticketvoucher.$refs.redepositTicketVoucher.show();
    },
    changedDepPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentDepPage = 1;
      this.getDepositList(true);
    },
    changedDepPage: function(pageNo) {
      this.currentDepPage = pageNo;
      this.getDepositList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>